import * as tslib_1 from "tslib";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import moment from "moment-timezone";
import AuthServiceFactory from "@/services/authentication/AuthServiceFactory";
import TransactionQueryRequest from "accounting-data-types/dist/APIG/Transaction/TransactionQueryRequest";
import AccountApiClient from "@/services/api/AccountingApiClient";
let TransactionHistoryView = class TransactionHistoryView extends Vue {
    constructor() {
        super();
        this.authService = AuthServiceFactory.GetAuthService();
        this.isLoggedIn = false;
        this.user = null;
        this.isLoading = false;
        this.currentPage = 1;
        this.totalPages = 0;
        this.showOptions = false;
        this.datesSelected = new Array();
        this.datesSelected.push(moment()
            .subtract(1, "week")
            .format("YYYY-MM-DD"));
        this.datesSelected.push(moment().format("YYYY-MM-DD"));
        this.searchDatesMenu = false;
        this.filtersMenu = false;
        this.transactionIdFilter = "";
        this.reportColumns = [
            {
                text: "Row ID",
                value: "RowID",
                display: true,
                mandatory: true,
                defaultView: true
            },
            {
                text: "Customer ID",
                value: "GPCustomerID",
                display: false,
                mandatory: false,
                defaultView: false
            },
            {
                text: "Name",
                value: "CustomerName",
                display: true,
                mandatory: false,
                defaultView: true
            },
            {
                text: "Email",
                value: "EmailAddress",
                display: true,
                mandatory: false,
                defaultView: true
            },
            {
                text: "Header ID",
                value: "HeaderSourceReferenceId",
                display: false,
                mandatory: false,
                defaultView: false
            },
            {
                text: "Total Amount",
                value: "TotalTransactionAmount",
                display: true,
                mandatory: false,
                defaultView: true
            },
            {
                text: "Configio Amount",
                value: "ConfigioAmount",
                display: false,
                mandatory: false,
                defaultView: false
            },
            {
                text: "GP Amount",
                value: "LineAmount",
                display: true,
                mandatory: false,
                defaultView: true
            },
            {
                text: "Transaction ID",
                value: "GPTransactionID",
                display: false,
                mandatory: false
            },
            {
                text: "Type",
                value: "TransactionType",
                display: true,
                mandatory: false,
                defaultView: true
            },
            {
                text: "Authorize ID",
                value: "AuthorizeID",
                display: true,
                mandatory: false,
                defaultView: true
            },
            {
                text: "Long Description",
                value: "LongDescription",
                display: false,
                mandatory: false,
                defaultView: false
            },
            {
                text: "Short Description",
                value: "ShortDescription",
                display: true,
                mandatory: false,
                defaultView: false
            },
            {
                text: "PO Number",
                value: "PONumber",
                display: true,
                mandatory: false,
                defaultView: true
            },
            {
                text: "Line ID",
                value: "LineSourceReferenceId",
                display: false,
                mandatory: false,
                defaultView: false
            },
            {
                text: "Transaction Date",
                value: "TransactionDate",
                display: true,
                mandatory: false,
                defaultView: false
            },
            {
                text: "Service Date",
                value: "ServiceDate",
                display: true,
                mandatory: false,
                defaultView: true
            },
            {
                text: "Import Status",
                value: "GPImportStatus",
                display: true,
                mandatory: false,
                defaultView: true
            },
            {
                text: "Invoice Number",
                value: "GPInvoiceNumber",
                display: true,
                mandatory: false,
                defaultView: true
            },
            {
                text: "Invoice Created",
                value: "GPInvoiceCreatedOn",
                display: false,
                mandatory: false,
                defaultView: false
            },
            {
                text: "Account",
                value: "GLAccount",
                display: true,
                mandatory: false,
                defaultView: true
            },
            {
                text: "Sub Account",
                value: "GLSubAccount",
                display: true,
                mandatory: false,
                defaultView: true
            },
            {
                text: "Product Account",
                value: "GLProductAccount",
                display: true,
                mandatory: false,
                defaultView: true
            }
        ];
        this.selectedReportColumns = this.reportColumns.filter(x => x.defaultView === true || x.mandatory === true);
        this.transactions = [];
        this.selectedStatuses2 = ["Queued For Import"];
        this.gpImportStatuses2 = ["Queued For Import", "Processed", "Failed"];
        this.gpImportStatuses = [
            {
                text: "Queued For Import",
                value: true
            },
            {
                text: "Processed",
                value: true
            },
            {
                text: "Failed",
                value: true
            }
        ];
        this.importDatesSelected = new Array();
        this.totalTransactions = 0;
    }
    async mounted() {
        let isLoggedIn = await this.authService.isLoggedIn();
        if (isLoggedIn === true) {
            this.user = await this.authService.getUser();
            await this.getResults();
        }
    }
    get availableReportFields() {
        return this.reportColumns.filter(x => x.mandatory === false);
    }
    async getResults() {
        console.log("Headers: " + JSON.stringify(this.selectedReportColumns));
        this.isLoading = true;
        this.transactions = [];
        let request = new TransactionQueryRequest();
        if (this.datesSelected.length > 0) {
            request.query.transactionTimeframe.startDate = moment(this.datesSelected[0]).format("YYYY-MM-DD 00:00:00");
            request.query.transactionTimeframe.endDate = moment(this.datesSelected[1]).format("YYYY-MM-DD 23:59:59");
        }
        if (this.importDatesSelected.length > 0) {
            request.query.importTimeframe.startDate = moment(this.importDatesSelected[0]).format("YYYY-MM-DD 23:59:59");
            request.query.importTimeframe.endDate = moment(this.importDatesSelected[1]).format("YYYY-MM-DD 23:59:59");
        }
        request.query.pagination.pageNumber = this.currentPage;
        request.query.pagination.numberOfResults = 10;
        request.query.gpImportStatuses = this.selectedStatuses;
        request.query.viewFields = this.viewFields;
        let accountingApiClient = new AccountApiClient(process.env.VUE_APP_API_ACCOUNTING_BASEURL, this.user);
        let response = await accountingApiClient.getTransactionAudit(request);
        this.transactions = response.transactions;
        this.totalTransactions = response.recordCount;
        this.totalPages = response.totalPages;
        console.log("Transactions: " + JSON.stringify(this.transactions));
        this.isLoading = false;
    }
    async fetchExport() {
        let request = new TransactionQueryRequest();
        if (this.datesSelected.length > 0) {
            request.query.transactionTimeframe.startDate = moment(this.datesSelected[0]).format("YYYY-MM-DD 00:00:00");
            request.query.transactionTimeframe.endDate = moment(this.datesSelected[1]).format("YYYY-MM-DD 23:59:59");
        }
        if (this.importDatesSelected.length > 0) {
            request.query.importTimeframe.startDate = moment(this.importDatesSelected[0]).format("YYYY-MM-DD 23:59:59");
            request.query.importTimeframe.endDate = moment(this.importDatesSelected[1]).format("YYYY-MM-DD 23:59:59");
        }
        request.query.pagination.pageNumber = 1;
        request.query.pagination.numberOfResults = this.totalTransactions;
        request.query.gpImportStatuses = this.selectedStatuses;
        request.query.viewFields = this.viewFields;
        let accountingApiClient = new AccountApiClient(process.env.VUE_APP_API_ACCOUNTING_BASEURL, this.user);
        let response = await accountingApiClient.getTransactionAudit(request);
        return response.transactions;
    }
    getFormattedDate(date) {
        return moment(date).format("YYYY-MM-DD");
    }
    get selectedGpImportStatuses() {
        return this.gpImportStatuses.filter(x => x.value === true);
    }
    get selectedStatuses() {
        return this.gpImportStatuses.filter(x => x.value === true).map(x => x.text);
    }
    get selectedDatesFormatted() {
        let dateMessage = "No dates selected";
        if (this.datesSelected.length > 0) {
            dateMessage = moment(this.datesSelected[0]).format("YYYY-MM-DD");
        }
        if (this.datesSelected.length > 1) {
            dateMessage = dateMessage
                .concat(" to ")
                .concat(moment(this.datesSelected[1]).format("YYYY-MM-DD"));
        }
        return dateMessage;
    }
    get reportHeaders() {
        return this.reportColumns.filter(x => x.display === true);
    }
    get viewFields() {
        return this.reportColumns
            .filter(x => x.display === true || x.mandatory === true)
            .map(x => x.value);
    }
    get exportFields() {
        let exportFields = {};
        for (let idx = 0; idx < this.reportHeaders.length; idx++) {
            let field = this.reportHeaders[idx];
            exportFields[field.text] = field.value;
        }
        return exportFields;
    }
    async optionsSaved() {
        this.showOptions = false;
        for (let idx = 0; idx < this.selectedReportColumns.length; idx++) {
            this.selectedReportColumns[idx].display = true;
        }
        await this.getResults();
    }
    optionsCanceled() {
        this.showOptions = false;
    }
    async pageChanged() {
        await this.getResults();
    }
    get exportFilename() {
        return "gp-transactions-".concat(moment(this.datesSelected[0]).format("YYYYMMDD")).concat("-").concat(moment(this.datesSelected[1]).format("YYYYMMDD")).concat(".csv");
    }
};
TransactionHistoryView = tslib_1.__decorate([
    Component({
        name: "TransactionHistory",
        components: {}
    })
], TransactionHistoryView);
export default TransactionHistoryView;
